import { queryFetch, fetchJson } from '@/utils/fetchutils';
import { combineRelativeUrlParts } from '@/utils/combineurl';

const getRoomsApiUrl = (rootGetters, path = '') => combineRelativeUrlParts(
  combineRelativeUrlParts(
    rootGetters['synclounge/GET_SERVER'] || rootGetters['synclounge/GET_BEST_SERVER'],
    'api/rooms',
  ),
  path,
);

const getAuthHeaders = (rootGetters) => ({
  'X-Plex-Token': rootGetters['plex/GET_PLEX_AUTH_TOKEN'],
});

export default {
  FETCH_MY_ROOMS: async ({ rootGetters, commit }) => {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    try {
      const rooms = await fetchJson(
        getRoomsApiUrl(rootGetters),
        null,
        { headers: getAuthHeaders(rootGetters) },
      );
      commit('SET_MY_ROOMS', rooms);
    } catch (e) {
      console.error(e);
      commit('SET_ERROR', 'Unable to fetch your rooms');
    }

    commit('SET_LOADING', false);
  },

  RECORD_ROOM_VISIT: async ({ rootGetters }, roomId) => {
    await queryFetch(
      getRoomsApiUrl(rootGetters, `${roomId}/visit`),
      null,
      { method: 'POST', headers: getAuthHeaders(rootGetters) },
    );
  },

  PIN_ROOM: async ({ dispatch, rootGetters }, roomId) => {
    await queryFetch(
      getRoomsApiUrl(rootGetters, `${roomId}/pin`),
      null,
      { method: 'PUT', headers: getAuthHeaders(rootGetters) },
    );
    await dispatch('FETCH_MY_ROOMS');
  },

  UNPIN_ROOM: async ({ dispatch, rootGetters }, roomId) => {
    await queryFetch(
      getRoomsApiUrl(rootGetters, `${roomId}/pin`),
      null,
      { method: 'DELETE', headers: getAuthHeaders(rootGetters) },
    );
    await dispatch('FETCH_MY_ROOMS');
  },

  FORGET_ROOM: async ({ dispatch, rootGetters }, roomId) => {
    await queryFetch(
      getRoomsApiUrl(rootGetters, roomId),
      null,
      { method: 'DELETE', headers: getAuthHeaders(rootGetters) },
    );
    await dispatch('FETCH_MY_ROOMS');
  },
};
